import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { PaymentRecordsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createPaymentRecord = (data): any => action(types.CREATE_PAYMENTRECORD_REQUESTED, data);

export const updatePaymentRecord = (data): any => action(types.UPDATE_PAYMENTRECORD_REQUESTED, data);

export const deletePaymentRecord = (paymentrecordId): any => action(types.UPDATE_PAYMENTRECORD_REQUESTED, paymentrecordId);

export const getPaymentRecord = (paymentrecordId): any => action(types.GET_PAYMENTRECORD_REQUESTED, paymentrecordId);

export const getAllPaymentRecords = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_PAYMENT_RECORDS_REQUESTED, { pagination, compile });

export const selectPaymentRecord = (paymentrecordId): any => action(types.SELECT_PAYMENTRECORD_REQUESTED, {
  currentPaymentRecordId: paymentrecordId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createPaymentRecordPending: (payload): any => action(types.CREATE_PAYMENTRECORD_PENDING, payload),
  createPaymentRecordsuccess: (response): any => {
    const currentPaymentRecord = response.entities.forfeits[response.result];
    history.push(`/payment/${currentPaymentRecord.paymentCollection.id}/review`);
    return action(types.CREATE_PAYMENTRECORD_SUCCESS, {
      paymentrecordsById: response.entities.forfeits,
      currentPaymentRecordId: response.result,
    });
  },
  updatePaymentRecordPending: (payload): any => action(types.UPDATE_PAYMENTRECORD_PENDING, payload),
  updatePaymentRecordsuccess: (response): any => action(types.UPDATE_PAYMENTRECORD_SUCCESS, {
    paymentrecordsById: response.entities.paymentrecords,
    currentPaymentRecordId: response.result,
  }),
  updatePaymentRecordFailed: (error): any => action(types.UPDATE_PAYMENTRECORD_FAIL, { backendErrors: error }),
  deletePaymentRecordPending: (): any => action(types.UPDATE_PAYMENTRECORD_PENDING, {}),
  deletePaymentRecordsuccess: (response, userId): any => {
    localStorage.set(userId, { currentPaymentRecordId: null });
    history.push('/paymentrecords');

    return action(types.DELETE_PAYMENTRECORD_SUCCESS, {
      currentPaymentRecordId: response,
    });
  },
  getPaymentRecordPending: (): any => action(types.GET_PAYMENTRECORD_PENDING, {}),
  getPaymentRecordsuccess: (response): any => action(types.GET_PAYMENTRECORD_SUCCESS, {
    paymentrecordsById: response.entities.paymentrecords,
    currentPaymentRecordId: response.result,
  }),
  getPaymentRecordFailed: (error): any => action(types.GET_PAYMENTRECORD_FAIL, { backendErrors: error }),
  deletePaymentRecordFailed: (error): any => action(types.UPDATE_PAYMENTRECORD_FAIL, { backendErrors: error }),
  getAllPaymentRecordsPending: (pagination): any => action(types.GET_ALL_PAYMENT_RECORDS_PENDING, { pagination }),
  getAllPaymentRecordsSuccess: (response, meta): any => action(types.GET_ALL_PAYMENT_RECORDS_SUCCESS, {
    paymentrecordsById: response.entities.paymentrecords,
    paymentrecordIds: response.result,
    meta,
  }),
  getAllPaymentRecordsFailed: (error): any => action(types.GET_ALL_PAYMENT_RECORDS_FAIL, { backendErrors: error }),
  createPaymentRecordFailed: (error): any => action(types.CREATE_PAYMENTRECORD_FAIL, { backendErrors: error }),
};

export default null;
